<template>
  <section
    class="payment-item"
    @click="routerDetail">
    <div class="d-flex align-items-center p-3">
      <div class="payment-item__icon">
        <!-- <picture class="img-fluid">
          <source
            srcset="@/assets/film-icon.webp"
            type="image/webp">
          <source
            srcset="@/assets/film-icon.png"
            type="image/png">

        </picture> -->
        <img
          src="@/assets/film-icon.png"
          alt=""
          width="86"
          height="78"
          class="img-fluid">
      </div>
      <div>
        <p class="my-0 px-3 text-truncate">商品名称: {{ data.type_info || '电子胶片' }}</p>
        <p class="my-0 px-3 text-truncate">订单号：{{ data.bill_code }}</p>
        <div class="d-flex">
          <div class="px-3 payment-item__content">
            <p class="my-0 text-truncate">创建时间：{{ data.create_time }}</p>
            <p class="my-0 text-truncate">支付状态：{{ data.bill_status }}</p>
          </div>
          <div class="text-warning text-right payment-item__price">
            {{ data.bill_current_price|currency }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import accounting from 'accounting';

export default {
  name: 'OrderListItem',
  filters: {
    currency(value) {
      return accounting.formatMoney(value / 100, '￥', 2, ',', '.');
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routerLink() {
      return `/cloud-film/account/order/${this.data.bill_code}`;
    },
  },
  methods: {
    routerDetail() {
      window.location.href = this.routerLink;
    },
  },
};
</script>

<style scoped>
.payment-item {
  background-color: #fff;
  color: #000;
  display: block;
}

.payment-item::after {
  content: ' ';
  display: block;
  margin-left: 1rem;
  height: 1px;
  background-color: #eee;
}

.payment-item:last-child::after {
  margin-left: 0;
}

.payment-item__icon {
  width: 48px;
}

.payment-item__price {
  width: 5rem;
}

.payment-item__content {
  flex: 1;
  max-width: calc(100% - 100px);
}
</style>
